import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "../../styles/index.less";

interface DashboardProps {
  activeTab: "REITs" | "InvITs";
  setActiveTab: (tab: "REITs" | "InvITs") => void;
}

const Dashboard: React.FC<DashboardProps> = ({ activeTab, setActiveTab }) => {

  // Feature card images
  const compareImg = new URL("../../assets/compare.png", import.meta.url).href;
  const understandImg = new URL("../../assets/understand.png", import.meta.url)
    .href;
  const valuationImg = new URL("../../assets/valuation.png", import.meta.url)
    .href;

  // Hero background images
  const heroBg = {
    REITs: new URL("../../assets/reitsListing.png", import.meta.url).href,
    InvITs: new URL("../../assets/invitsListing.jpg", import.meta.url).href,
  };

  return (
    <>
      {/* -------------------- HERO SECTION -------------------- */}
      <section className="homepage1">
        {/* Background layers */}
        <div
          className="bg-layer"
          style={{
            backgroundImage: `url(${heroBg["REITs"]})`,
            opacity: activeTab === "REITs" ? 1 : 0,
            backgroundPosition: "center",
          }}
        />
        <div
          className="bg-layer"
          style={{
            backgroundImage: `url(${heroBg["InvITs"]})`,
            opacity: activeTab === "InvITs" ? 1 : 0,
            backgroundPosition: "bottom",
          }}
        />

        <div className="homepage1__overlay">
          {/* Toggle Buttons */}
          <div className="homepage1__tabs">
            <button
              className={`tab ${activeTab === "REITs" ? "active" : ""}`}
              onClick={() => setActiveTab("REITs")}
            >
              REITs
            </button>
            <button
              className={`tab ${activeTab === "InvITs" ? "active" : ""}`}
              onClick={() => setActiveTab("InvITs")}
            >
              InvITs
            </button>
          </div>

          {/* Description */}
          <p className="homepage1__desc">
            {(activeTab === "REITs"
              ? [
                  "Invest in high-quality commercial real estate through the securities markets",
                  "REITs offer steady income, portfolio diversification,",
                  "and long-term growth opportunities.",
                ]
              : [
                  "Invest in the backbone of the economy through the securities markets",
                  "InvITs deliver long-term, predictable income",
                  "from infrastructure projects you rely on every day.",
                ]
            ).map((line, idx) => (
              <span key={idx}>
                {line}
                <br />
              </span>
            ))}
          </p>

          {/* CTA */}
          <NavLink to={`/${activeTab.toLowerCase()}`}>
            <button className="homepage1__cta">Explore {activeTab}</button>
          </NavLink>
        </div>
      </section>

      {/* -------------------- FEATURE SECTION -------------------- */}
      <section className="feature-section">
        <h2 className="feature-title">
          Why use this platform <br />
          {/* <span>Smarter than the rest</span> */}
        </h2>

        <div className="feature-cards">
          <div className="feature-card">
            <h3>Understand Before You Act</h3>
            <p>Know the story behind every number before you make your move</p>
            <img
              src={understandImg}
              alt="Understand Before You Act"
              className="feature-img"
            />
          </div>

          <div className="feature-card">
            <h3>Compare Like a Pro</h3>
            <p>Spot the differences that matter and choose with confidence</p>
            <img
              src={compareImg}
              alt="Compare Like a Pro"
              className="feature-img"
            />
          </div>

          <div className="feature-card">
            <h3>Get Valuation Insights</h3>
            <p>
              Build valuations your way — adjust assumptions and see results
              instantly
            </p>
            <img
              src={valuationImg}
              alt="Get Valuation Insights"
              className="feature-img"
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Dashboard;
